import { column, Table, useGrid } from "@podtrac/common/grid";
import { useNavigate, useParams } from "react-router-dom";
import {
    useShowRankingsSpotify,
    useShowRankingsSpotifyMonths,
} from "../rankings-api";
import styles from "../rankings.module.scss";
import { CountryCell } from "./country-cell";
import { SortButton } from "../sort-button";
import { MonthCell } from "./month-cell";
import { ElideCell } from "./elide";
import { MonthDropDown } from "./month-drop-down";

export function ShowRankingsSpotify() {
    const navigate = useNavigate();
    const { accountID, showID, month } = useParams();
    const { data: months } = useShowRankingsSpotifyMonths(accountID, showID);
    const query = useShowRankingsSpotify(accountID, showID, month);
    const grid = useGrid({
        data: query.data,
        enableSorting: true,
        columns,
        defaultColumn: {
            headerAlign: "center",
            header: SortButton,
        },
    });

    const rowClick = (event, row) => {
        event.preventDefault();
        const { spotifyID, chartSanitized, countryCode } = row.original;
        //console.log({ chart, countryCode });
        navigate(`../${spotifyID}/${chartSanitized}/${countryCode}`, { state: { month } });
    };

    return (
        <>
            <header className={styles.header}>
                <h1>Spotify Rankings</h1>
                <label htmlFor="month">Month</label>
                <MonthDropDown id="month" months={months} />
                <span />
                <button
                    type="button"
                    onClick={grid.exportCsv("Spotify Rankings.csv")}
                >
                    Export
                </button>
            </header>
            <Table
                grid={grid}
                className={`${styles.grid} ${styles.hover}`}
                onRowClick={rowClick}
            />
            {/*<pre>{JSON.stringify(query, null, 2)}</pre>*/}
        </>
    );
}

const columns = [
    column.accessor("date", {
        id: "Month",
        align: "center",
        cell: MonthCell,
    }),
    column.accessor("title", {
        id: "Title",
        align: "left",
        cell: ElideCell,
    }),
    column.accessor("category", {
        id: "Category",
        align: "left",
        cell: CategoryCell,
    }),
    column.accessor("country", {
        id: "Country",
        align: "left",
        cell: CountryCell,
    }),
    column.accessor("minRank", {
        id: "Highest Rank",
        align: "right",
    }),
    column.accessor("avgRank", {
        id: "Average Rank",
        align: "right",
    }),
    column.accessor("maxRank", {
        id: "Lowest Rank",
        align: "right",
    }),
];

function CategoryCell({ row }) {
    const { category, subcategory } = row.original;
    return category + (subcategory ? "/" + subcategory : "");
}
